let React = require("react");

let Avatar = require("./Avatar.jsx");

let ApplicationContext = require("../config/ApplicationContext.js");
let Application =        require("../Application.js");

class UserInfo extends React.Component {

    constructor(){
        super();

        this.state = {show: false}

        this.isDesktop = window.innerWidth < 1084 ? false: true;
        this.logout = this.logout.bind(this);
        this.onClick = this.onClick.bind(this);
        this.hideBrothers = this.hideBrothers.bind(this);
    }

    componentDidMount(){
        window.matchMedia('(max-width: 1084px)').addListener(event => this.isDesktop = !event.matches)
    }

    shouldComponentUpdate(nextProps, nextState){
        return this.state.show !== nextState.show;
    }

    onClick(){
        if(this.isDesktop){
            this.setState(prev => ({show: !prev.show}))
        }
    }
    
    hideBrothers(){
        this.setState({show: false})
    }

    logout() {
        googleGA("send", "event", "libraries", "signout");
        Application.dataStore.logoutUser();
    }

    edit() {
        window.open(`${ApplicationContext.adskAccountUrl}/Profile/EditProfile?theme=light`, '_blank');
    }
    
    render() {
        let { avatar, name = "", email = ""} = ApplicationContext.getUserData();
        return  <div className="userInfo" onBlur={this.hideBrothers}>
                    <button className="button noButton" onClick={this.onClick}>
                        <Avatar url={avatar}/>
                    </button>
                    <div className={`userInfo__container ${this.state.show? "--show": ""}`}>
                        <h3>{name}</h3>
                        <h4>{email}</h4>
                        <div className="userInfo__container__options">
                            <button className="button" onMouseDown={this.edit}>Edit profile</button>
                            <button className="button transparent" onMouseDown={this.logout}>Sign Out</button>
                        </div>
                    </div>
                </div>
    }
}

module.exports = UserInfo;
